import { updateView } from '../../current-view/actions/updateView';
import { THREAD_VIEW } from '../../current-view/constants/views';
import { getOriginViewContext } from '../../kb-article/kbArticleSelectors';
import { selectThread } from '../../selected-thread/actions/selectThread';
import { setStandardWidgetSize } from '../../widget-size/widgetSizeSlice';
// @ts-expect-error untyped module
import { getCurrentThreadId } from '../../thread-history/selectors/getCurrentThreadId';
export function restorePreviousViewFromKBArticle() {
  return (dispatch, getState) => {
    const {
      view
    } = getOriginViewContext(getState());
    dispatch(setStandardWidgetSize());
    if (view === THREAD_VIEW) {
      dispatch(selectThread(getCurrentThreadId(getState())));
    }
    dispatch(updateView(view));
  };
}